
export const HandleDecimal = (e,callback)=>{

    if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
        let { value, min, max } = e.target;
        if(min && max && (e.target.value !== "")){
            if(Number(value)>=Number(min) && Number(value) <= Number(max))
            callback(e);
            
        } else{
            callback(e);
        }
  }
};


export const GetOrganizationName = (formData) => {
    if (!formData)
        return null;
    const form = JSON.parse(formData);
    return form.politicalOrganizationName;
};



export const cleanCsvString = (str,separator, removeDuplicates)=> {

    // default to true
    removeDuplicates = (removeDuplicates === undefined) ? true : removeDuplicates;

    // go through each item
    return String(str).split(separator).map(function(item) {
        // trim value
        return String(item).trim();
    })
    .filter(function(item, index, all) {

        if (removeDuplicates) {
            // remove empty items & duplicate values
            return (item !== '') && (index === all.indexOf(item));
        }

        return item;
    })
    .join(separator);
};